import adapter from './adapter'
import { collectionGetters } from '@/store/collection'
import { RescueCode } from './model'

const { getAll, getCollection, findGetter } = collectionGetters(adapter, {
  constructor: data => new RescueCode(data)
})

export default {
  getAll,
  getCollection,
  getRescueCode: (state, getters) => code => findGetter(state, getters)(rescueCode => {
    return rescueCode.code.toLocaleLowerCase() === code.toLocaleLowerCase() || rescueCode.id.toLocaleLowerCase() === code.toLocaleLowerCase();
  }),
}
